import React from 'react';
import moment from "moment";

import { Grid } from '@material-ui/core';

import NonFieldErrors from '../../../../../components/AssetModal/components/NonFieldErrors';
import {decimalStrToNumber} from "../../../../../utils/utils";
import SelectFormElementV2
  from "../../../../RiskProfiling/components/StepContent/components/formElement/SelectFormElementV2";
import InputFormElement
  , {CurrencyNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement";
import CalendarFormElement
  from "../../../../RiskProfiling/components/StepContent/components/formElement/CalendarFormElement";
import {newDesignInputCustomClasses} from "../../../../RiskProfiling/constants";
import {DEMANDS_CATEGORY, newDesignInputCustomClassesViewOnly} from "../../../constants";
import {PercentageNumberFormat} from "../../../../RiskProfiling/components/StepContent/components/formElement/InputFormElement/InputFormElement";
import {dateToMoment, momentToDate} from "../../utils";


const DemandForm = (props) => {

  const {
    handleFormChange,
    defaults,
    errors,
    viewOnly
  } = props;

  const [model, setModel] = React.useState({
    sub_category: defaults.sub_category ? String(defaults.sub_category) : null,
    name: defaults.name,
    value: decimalStrToNumber(defaults.value),
    original_value: decimalStrToNumber(defaults.original_value),
    start_date: dateToMoment(defaults.start_date),
    monthly_amount: decimalStrToNumber(defaults.monthly_amount),
    interest_rate: decimalStrToNumber(defaults.interest_rate),
    updated: dateToMoment(defaults.updated),
  });

  React.useEffect(() => {
    handleFormChange && handleFormChange({
      ...model,
      start_date: momentToDate(model.start_date),
    });
  }, [model]);

  const handleModelChange = (field) => (value) => {
    setModel({
      ...model,
      [field]: value
    })
  };

  const inputClasses = viewOnly ? newDesignInputCustomClassesViewOnly : newDesignInputCustomClasses;

  return (
    <>
      {!viewOnly && (
        <Grid item xs={12}>
          <SelectFormElementV2
            label="Kategorie"
            value={model.sub_category}
            options={DEMANDS_CATEGORY.subCategories}
            onChange={handleModelChange('sub_category')}
            dataId={'category-input'}
            disabled={viewOnly}
            required
            newDesign
          />
        </Grid>
      )}
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label={'Name / Bezeichnung'}
          required={!viewOnly}
          value={model.name}
          error={errors.name}
          onChange={handleModelChange('name')}
          dataId={'name-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Ursprünglicher Wert"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.original_value}
          error={errors.original_value}
          onChange={handleModelChange('original_value')}
          dataId={'original_value-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <InputFormElement
          label="Wert / Höhe (aktuell)"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.value}
          error={errors.value}
          onChange={handleModelChange('value')}
          dataId={'value-input'}
          required={!viewOnly}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={6}>
        <CalendarFormElement
          label="Forderungsbeginn"
          value={model.start_date}
          error={errors.start_date}
          onChange={handleModelChange('start_date')}
          dataId={'start_date-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Monatliche Rückzahlung"
          inputComponent={CurrencyNumberFormat}
          inputProps={{inputProps: {allowNegative: false}}}
          value={model.monthly_amount}
          error={errors.monthly_amount}
          onChange={handleModelChange('monthly_amount')}
          dataId={'monthly_amount-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <InputFormElement
          label="Verzinsung"
          inputComponent={PercentageNumberFormat}
          inputProps={{inputProps: {allowNegative: false, isAllowed: (values) => {
            const {floatValue} = values;
            return !floatValue || floatValue <= 100;
          }}}}
          value={model.interest_rate}
          error={errors.interest_rate}
          onChange={handleModelChange('interest_rate')}
          dataId={'interest_rate-input'}
          disabled={viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <CalendarFormElement
          label="Stand vom"
          value={model.updated || moment()}
          dataId={'updated-input'}
          disabled
          required={!viewOnly}
          custom_classes={inputClasses}
        />
      </Grid>
      {!!errors['non_field_errors'] && <NonFieldErrors errors={errors['non_field_errors']}/>}
    </>
  )
};

DemandForm.defaultProps = {
  defaults: {},
  errors: {}
};

export default DemandForm;